export default __webpack_public_path__ + "static/media/metamask.38df2c78.png";